import "./style.css";
import "./Classes/Experience";
import Experience from "./Classes/Experience";

const experience = new Experience(document.querySelector(".experience-canvas"));
